// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrcode-container {
  padding: 15px;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.qrcode-container .full-name, .qrcode-container .birth-date {
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  margin: 2px auto;
}
.qrcode-container .image-wrapper {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
}
.qrcode-container .image-wrapper img {
  width: 100%;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/request-qrcode/request-qrcode.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AAAI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAER;AAAI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAER;AADQ;EACI,WAAA;EACA,cAAA;AAGZ","sourcesContent":[".qrcode-container {\n    padding: 15px;\n    height: calc(100% - 30px);\n    width: calc(100% - 30px);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    .full-name, .birth-date {\n        font-size: 1em;\n        font-weight: bold;\n        text-align: center;\n        margin: 2px auto;\n    }\n    .image-wrapper {\n        flex: 1 1 auto;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        max-width: 500px;\n        img {\n            width: 100%;\n            margin: 0 auto;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
